import { SETTING_PACS_CONNECTION_COLUMN_WITHOUT_STATUS } from 'config/tableColumns';
import useGetDicomNodes from '@hooks/PACS/usePacs';
import { DicomNodeParams } from '@models/pacs';
import { useState } from 'react';
import styles from './AutoCaptureModalContent.module.scss';
import Button from '@components/Button';
import AutoCaptureTable from '@components/Table/AutoCaptureTable';

type AutoCaptureModalContentProps = {
  onConfirm: (info: DicomNodeParams[]) => void;
};

export default function AutoCaptureModalContent({
  onConfirm,
}: AutoCaptureModalContentProps) {
  const [selectedKeys, setSelectedKeys] = useState<React.Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<DicomNodeParams[]>([]);
  const { data } = useGetDicomNodes();

  const handleConfirm = () => {
    onConfirm(selectedRows);
  };

  const toggleSelect = (key: React.Key, row: DicomNodeParams) => {
    setSelectedKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
    );
    setSelectedRows((prev) =>
      prev.some((r) => r.id === row.id)
        ? prev.filter((r) => r.id !== row.id)
        : [...prev, row],
    );
  };

  return (
    <div className={styles['Report-modal-container']}>
      <div className={styles['table-box']}>
        <AutoCaptureTable
          columns={SETTING_PACS_CONNECTION_COLUMN_WITHOUT_STATUS}
          data={data}
          getRowId={(r) => r.id}
          onRowClick={(key, row) => toggleSelect(key, row as DicomNodeParams)}
          selectedKey={selectedKeys}
        />
      </div>
      <div className={styles['button-box']}>
        <Button
          className="action-control confirm"
          onClick={handleConfirm}
          disabled={selectedKeys.length === 0}
        >
          Confirm
        </Button>
      </div>
    </div>
  );
}
